import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/401.webp")